import {Sku} from "./Sku";

export class Price {
    constructor(week, price, paypal, stripe) {
        this.week = week;
        this.price = price;
        this.sku = new Sku(paypal, stripe)
        this.unit = "$";
    }
    getPrice() {
        return `${this.unit}${this.price.toFixed(2)}`;
    }
    getPerDayPrice() {
        return `${this.unit}${(this.price / (this.week * 7)).toFixed(2)}`;
    }
    getPerDayPriceWithoutUnit() {
        return `${(this.price / (this.week * 7)).toFixed(2)}`;
    }
}